import {
  CREATE_USER,
  CREATE_USER_SUCCESS,
  CREATE_USER_ERROR,
  CLEAN_USER_STORE,
} from './constants';

const INITIAL_STATE = {
  user: {
    social: [],
    deletionRequested: false,
    onboarded: false,
    isExpert: false,
    createdAt: null,
    updatedAt: null,
    _id: '',
    tenantId: '',
    kids: [],
    __v: null,
  },
  loading: false,
  error: null,
};

const userReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CREATE_USER:
      return { ...state, loading: true };
    case CREATE_USER_SUCCESS:
      return { ...state, loading: false, user: action.payload, error: null };
    case CREATE_USER_ERROR:
      return { ...state, loading: false, error: action.payload };
    case CLEAN_USER_STORE:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default userReducer;
